import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { ROUTES } from '../constants'

/**
 * Composant pour protéger les routes nécessitant une authentification
 * @param {Object} props - Props du composant
 * @param {React.ComponentType} props.component - Composant à rendre si authentifié
 */
const ProtectedRoute = ({ component: Component }) => {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuth()

  useEffect(() => {
    if (!isAuthenticated) {
      navigate(ROUTES.LOGIN)
    }
  }, [isAuthenticated, navigate])

  return isAuthenticated ? <Component /> : null
}

export default ProtectedRoute
